var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'debug-screens': _vm.devMode },attrs:{"id":"app"}},[_c('div',{staticClass:"container mx-auto"},[_c('div',{staticClass:"px-4 xl:px-0 h-full pt-20"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }